import { Link } from "react-router-dom";

const features = [
  {
    icon: "bi-telephone-fill",
    title: "Votre numéro actuel",
    text: "Envoyez et recevez des textos directement depuis votre numéro professionnel existant — pas besoin d'en obtenir un nouveau.",
  },
  {
    icon: "bi-laptop",
    title: "Application web et mobile",
    text: "Une interface de conversation simple, accessible depuis un ordinateur ou l'application mobile, pour répondre où que vous soyez.",
  },
  {
    icon: "bi-people-fill",
    title: "Plusieurs employés, une boîte commune",
    text: "Toute l'équipe peut voir et répondre aux conversations, avec un suivi clair de qui a pris en charge quoi.",
  },
  {
    icon: "bi-megaphone-fill",
    title: "Envois groupés",
    text: "Rappels de rendez-vous, confirmations ou promotions envoyées à plusieurs contacts à la fois.",
  },
  {
    icon: "bi-reply-fill",
    title: "Réponses automatiques",
    text: "Configurez des réponses rapides pour les questions fréquentes de vos patients ou clients.",
  },
  {
    icon: "bi-bar-chart-fill",
    title: "Suivi des statistiques",
    text: "Visualisez le volume de messages, les temps de réponse et l'historique complet de vos conversations.",
  },
];

export default function TelephonieSMS() {
  return (
    <>
      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Téléphonie &middot; textos</span>
              <h1 className="fw-900 mt-3 display-5">Textos pour entreprises</h1>
              <p className="lead text-secondary mt-3">
                Utilisez votre numéro de téléphone professionnel pour envoyer et
                recevoir des textos. Les messages peuvent être consultés et
                traités directement dans l’application ou par courriel,
                facilitant les échanges avec les patients tout en préservant la
                confidentialité des numéros personnels de votre équipe.
              </p>

              <div className="hero-btns mt-4">
                <div className="price-pill">
                  À partir de <strong>10,00&nbsp;$</strong> / mois
                </div>
                <Link
                  to="/contact"
                  className="btn btn-brand btn-lg rounded-pill px-4"
                >
                  Activer les textos pour mon numéro
                </Link>
              </div>
              {/* NOTE FRAIS */}
              <p
                className="text-secondary mt-3 mb-0"
                style={{ fontSize: "0.85rem" }}
              >
                <i className="bi bi-info-circle me-1 text-brand"></i>
                Des frais de configuration et d'installation peuvent s'appliquer
                lors de la mise en place du service.
              </p>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="call-card p-4">
                <div className="d-flex justify-content-between align-items-center pb-3 border-bottom">
                  <span className="font-mono small text-secondary">
                    TEXTOS REÇUS PAR COURRIEL
                  </span>
                  <span className="pulse-dot"></span>
                </div>

                <div className="sms-flow mt-4">
                  {/* Étape 1 : SMS envoyé par le client */}
                  <div className="sms-flow-step">
                    <div className="sms-flow-icon sms-flow-icon-sms">
                      <i className="bi bi-chat-dots-fill"></i>
                    </div>
                    <div className="sms-bubble">
                      <p
                        className="small fw-bold mb-1"
                        style={{ color: "var(--cpuc-black)" }}
                      >
                        Karine D. &middot; (418) 555-0142
                      </p>
                      <p className="small text-secondary mb-0">
                        Bonjour, est-ce que je peux déplacer mon rendez-vous à
                        14h ?
                      </p>
                    </div>
                  </div>

                  <div className="sms-flow-arrow">
                    <i className="bi bi-arrow-down"></i>
                  </div>

                  {/* Étape 2 : reçu par courriel */}
                  <div className="sms-flow-step">
                    <div className="sms-flow-icon sms-flow-icon-mail">
                      <i className="bi bi-envelope-fill"></i>
                    </div>
                    <div className="email-bubble">
                      <p className="font-mono small text-secondary mb-1">
                        De : sms@cpucsolutions.com
                      </p>
                      <p
                        className="small fw-bold mb-1"
                        style={{ color: "var(--cpuc-black)" }}
                      >
                        Nouveau texto de Karine D.
                      </p>
                      <p className="small text-secondary mb-0">
                        « Bonjour, est-ce que je peux déplacer mon rendez-vous à
                        14h ? »
                      </p>
                    </div>
                  </div>
                </div>

                <p className="small text-secondary text-center mt-4 mb-0">
                  Répondez directement depuis l'application ou par courriel — au
                  choix.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*
<section className="section pt-0">
  <div className="container">
    <span className="eyebrow" data-aos="fade-up">
      Ce que ça permet
    </span>

    <h2 className="fw-900 mt-3" data-aos="fade-up">
      Une messagerie texte pensée pour une équipe
    </h2>

    <div className="row g-4 mt-3">
      {features.map((f, i) => (
        <div
          className="col-md-6 col-lg-4"
          key={f.title}
          data-aos="fade-up"
          data-aos-delay={(i % 3) * 100}
        >
          <div className="service-card p-4">
            <div className="service-icon mb-3">
              <i className={`bi ${f.icon}`}></i>
            </div>
            <h3 className="h6 fw-bold">{f.title}</h3>
            <p className="text-secondary small mb-0">{f.text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
*/}

      <section className="section bg-cream">
        <div className="container">
          <div
            className="quote-block p-4 p-md-5 text-center"
            data-aos="zoom-in"
          >
            <h2 className="fw-900 mb-3" style={{ color: "#fff" }}>
              On configure les textos sur votre numéro actuel
            </h2>
            <p className="mb-4" style={{ color: "rgba(255,255,255,0.85)" }}>
              Aucun changement de numéro requis — on l'active directement sur
              celui que vos clients connaissent déjà.
            </p>
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill px-4"
              style={{
                background: "#fff",
                color: "var(--cpuc-red)",
                fontWeight: 700,
              }}
            >
              Discuter de mon projet
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
